import React from "react";
import PropTypes from "prop-types";
import { HeaderContainer, AppLogo, AppUser, AppActions } from "./styles.js";

const AppHeader = ({
  headerLogoComponent: HeaderLogo,
  headerInfoComponent: HeaderInfo,
  headerActionsComponent: HeaderActions,
  headerProps,
}) => {
  return (
    <HeaderContainer>
      <AppLogo>
        <HeaderLogo />
      </AppLogo>
      <AppUser>{HeaderInfo}</AppUser>
      <AppActions>
        <HeaderActions {...headerProps} />
      </AppActions>
    </HeaderContainer>
  );
};

AppHeader.propTypes = {
  headerLogoComponent: PropTypes.any.isRequired,
  headerInfoComponent: PropTypes.any.isRequired,
  headerActionsComponent: PropTypes.any.isRequired,
  headerProps: PropTypes.any,
};

export default AppHeader;
